module.exports = __webpack_public_path__ + "media/bell.2a29bac9.mp3";